import React, { Component } from "react";
import "./Banner.css";
import Piggy from "./saastopossu.svg"
import { Container, Row, Col, Visible, Hidden, ScreenClassRender } from 'react-grid-system';

class Info extends Component {
  render() {
    return (
      <div className="banner">
      <Container>
      <Row>
      <Col md={7}>
        <span className="banner-first">Lainaa hakemassa?</span>
        <span className="banner-second">Laina-apu kertoo kaiken oleellisen lainatuotteista ja mistä voit hakea lainaa.</span>
      </Col>
      <Col md={5}>
      	<img src={Piggy} alt="Saastopossu" className="banner-img"/>
      </Col>
      </Row>
      </Container>
      </div>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx